var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAddGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_add_gray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-04-open",
    transform: "translate(-909.000000, -659.000000)",
    fill: "#5E6C80",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(522.000000, 363.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-circle",
    transform: "translate(387.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0.45 C15.2743194,0.45 19.55,4.72568064 19.55,10 C19.55,15.2743194 15.2743194,19.55 10,19.55 C4.72568064,19.55 0.45,15.2743194 0.45,10 C0.45,4.72568064 4.72568064,0.45 10,0.45 Z M10,1.55 C5.33319386,1.55 1.55,5.33319386 1.55,10 C1.55,14.6668061 5.33319386,18.45 10,18.45 C14.6668061,18.45 18.45,14.6668061 18.45,10 C18.45,5.33319386 14.6668061,1.55 10,1.55 Z M10,4.54090909 C10.273381,4.54090909 10.5001762,4.74036623 10.5428014,5.00169623 L10.55,5.09090909 L10.549,9.45 L14.9090909,9.45 C15.2128475,9.45 15.4590909,9.69624339 15.4590909,10 C15.4590909,10.273381 15.2596338,10.5001762 14.9983038,10.5428014 L14.9090909,10.55 L10.549,10.55 L10.55,14.9090909 C10.55,15.2128475 10.3037566,15.4590909 10,15.4590909 C9.72661905,15.4590909 9.49982381,15.2596338 9.45719857,14.9983038 L9.45,14.9090909 L9.449,10.55 L5.09090909,10.55 C4.78715248,10.55 4.54090909,10.3037566 4.54090909,10 C4.54090909,9.72661905 4.74036623,9.49982381 5.00169623,9.45719857 L5.09090909,9.45 L9.449,9.45 L9.45,5.09090909 C9.45,4.78715248 9.69624339,4.54090909 10,4.54090909 Z",
    id: "icon_add_gray"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddGray);
export default __webpack_public_path__ + "static/media/icon_add_gray.74b43fcba02e8aea9fa673256f773b56.svg";
export { ForwardRef as ReactComponent };